/* global I18n */

import React, {Suspense} from "react"
import StatsBox from "components/stats_box"
import LoadingImage from "./loading_image"
let QuizResults

export default QuizResults = ({
  success_rate = 0,
  practice_time = "0:00",
  points_earned = 0,
  bad_term_list = [],
  intro_text,
  description
}) => (
  <div className="embedded-quiz__results">
    <div className="last-training-stats">
      {!!description &&
        <p className="tiny hide-md-lg-only">{description}</p>}
      <p className="tiny">
        {intro_text}
      </p>
      <div className="stats-boxes">
        <StatsBox
          title={I18n.t("js.embedded_quiz.quiz_stats_summary.success_rate")}
          value={`${success_rate}%`}
        />
        <StatsBox
          title={I18n.t("js.embedded_quiz.quiz_stats_summary.practice_time")}
          value={practice_time}
        />
        <StatsBox
          title={I18n.t("js.embedded_quiz.quiz_stats_summary.points_earned")}
          value={points_earned}
        />
      </div>
    </div>
    {!!bad_term_list.length &&
      <div className="last-training-worst-terms">
        <p className="tiny">
          {I18n.t("js.embedded_quiz.quiz_stats_summary.your_weak_spots", {
            count: Math.min(bad_term_list.length, 3),
            max_count: bad_term_list.length
          })}
        </p>
        <div className="anatomyterms">
          {bad_term_list.map((term, index) => (
            <TermBox
              key={index}
              title={term.name}
              link_url={term.atlas_path}
              img_url={term.thumb}
            />
          ))}
        </div>
      </div>}
  </div>
)

const TermBox = ({title, img_url, link_url}) => (
  <a className="anatomyterm" href={link_url}>
    <div className="anatomyterm__image">
      <LoadingImage image_url={img_url} title={title} />
    </div>
    <div className="anatomyterm__bottom">
      <div className="anatomyterm-title">{title}</div>
    </div>
  </a>
)

QuizResults.displayName = "QuizResults"
